var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M27.1,13.06C24.38-3.4.62,2.87,6.26,18.53h-.1c-8.21.58-8.21,12.53,0,13.11.1,0,.32,0,.64,0-.67-1.46-1.05-3.06-1.08-4.71-.06-3.12,1.1-6.09,3.25-8.35.13-.14.27-.28.41-.41,4.59-4.37,11.74-4.35,16.31.05,2.27,2.19,3.55,5.12,3.61,8.27.03,1.66-.29,3.27-.91,4.75,1.34-.4,2.58-1.1,3.64-2.06,5.75-5.04,2.68-15.15-4.92-16.13Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,21.85c2.69,0,4.86,2.18,4.86,4.86,0,.69-.15,1.38-.43,2.01l-6.43-6.44c.63-.29,1.31-.43,2-.43M11.75,20.74c-.08.07-.15.14-.22.22-3.18,3.3-3.08,8.55.22,11.72,3.3,3.18,8.55,3.08,11.72-.22,3.18-3.3,3.08-8.55-.22-11.72-3.21-3.09-8.29-3.09-11.51,0M19.51,31.14c-2.44,1.11-5.33.03-6.44-2.42-.58-1.28-.58-2.74,0-4.02l6.44,6.44Z",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudOff);
export default __webpack_public_path__ + "static/media/cloud_off.f6461377eb86e9e39d5f599d8bdd4f20.svg";
export { ForwardRef as ReactComponent };